<template lang="pug">
  b-button.border-0.text-white.text-uppercase.font-weight-bold.mx-2.animated.tada.delay-3s(v-if="canStream" @click='stream' ref='startPublishButton' :class="[isStreaming ? 'bg-success' : 'bg-danger']")
    i.fa.fa-video-camera.text-light(style="font-size: 2.5vh")
  //.mx-5(v-if="canStream")
    button.btn.btn-lg.btn-success.btn-block.btn-login.text-white.text-uppercase.font-weight-bold.my-3(type='button' ref='startPublishButton' :class="[isStreaming ? 'visible' : 'visible']") Start
    button.btn.btn-lg.btn-danger.btn-block.btn-login.text-white.text-uppercase.font-weight-bold.my-3(type='button' ref='stopPublishButton' :class="[isStreaming ? 'visible' : 'visible']") Stop
</template>

<script>
import sdk from "phenix-web-sdk";
import { Timber } from "@timberio/browser";
const logger = new Timber(
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2FwaS50aW1iZXIuaW8vIiwiZXhwIjpudWxsLCJpYXQiOjE1ODU1ODc4MTEsImlzcyI6Imh0dHBzOi8vYXBpLnRpbWJlci5pby9hcGlfa2V5cyIsInByb3ZpZGVyX2NsYWltcyI6eyJhcGlfa2V5X2lkIjo2MzYzLCJ1c2VyX2lkIjoiYXBpX2tleXw2MzYzIn0sInN1YiI6ImFwaV9rZXl8NjM2MyJ9.p4ombS41LAMML8KUnEfBmfpVzgo2JV3EinywjZ_bmDQ",
  "35544"
);

var publisher = null;
// var screenPublisher = null;
// var lowQualityPublisher = null;
var roomService = null;
var roomExpress = null;
//var screenName = "ScreenName" + Math.floor(Math.random() * 10000) + 1; // Helpful if unique but we don't enforce this. You might set this to be an email or a nickname, or both. Then parse it when joining the room.
//var memberRole = "Participant";
var membersStore = [];
var memberSubscriptions = {};
var videoSources = [];
var audioSources = [];
var sendMessageIntervalId;
var isMobileAppleDevice =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var isOtherMobile = /Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
  navigator.userAgent
);

export default {
  name: "FanFestService",
  data() {
    return {
      numMembers: 0,
      isStreaming: false,
      didSelectUserCam: true
    };
  },
  computed: {
    canHost: function() {
      return this.$store.state.fanfest.canHost;
    }
  },
  props: {
    videoList: Array, // other streamers
    selfVideoList: Object, // my stream
    screenName: String,
    canStream: Boolean,
    // streamButton: Object,
    shouldMute: Boolean
  },
  watch: {
    shouldMute: function() {
      this.checkMute();
    },
    numMembers: function() {
      setTimeout(() => {
        const self = this;
        if (self.numMembers === 0) return;

        let numStreamers = self.$store.state.fanfest.hasHost ? self.numMembers - 1 : self.numMembers;
        if (numStreamers === 0) return;
        
        // Only applies to streamers not host
        let divToUpdate = self.$props.videoList[0];
        divToUpdate.children.forEach(function(v) {          
          v.classList.remove(
            "fanfest-video-1",
            "fanfest-video-4",
            "fanfest-video-9",
            "d-block",
            "d-none",
            "mx-auto"
          );

          if (numStreamers === 1 || (self.$store.state.fanfest.hasHost && self.numMembers === 2))
            v.classList.add("fanfest-video-1", "d-block", "mx-auto");
          else if (numStreamers >= 2 && numStreamers <= 4)
            v.classList.add("fanfest-video-4");
          else v.classList.add("fanfest-video-9");
        });
      }, 5000);
    }
  },
  mounted: function() {
    this.init();

    // Plugin might load with delay
    if (sdk.utils.rtc.phenixSupported && !sdk.utils.rtc.isPhenixEnabled()) {
      sdk.utils.rtc.onload = function() {
        this.init();
      };
    }
  },
  methods: {
    init: function() {
      const self = this;

      setUserMessage(
        "device is mobile: " + (isMobileAppleDevice || isOtherMobile)
      );

      var createRoomExpress = function createPCastExpress() {
        var adminApiProxyClient = new sdk.net.AdminApiProxyClient();

        adminApiProxyClient.setBackendUri(
          "https://demo-integration.phenixrts.com/pcast"
        );
        adminApiProxyClient.setAuthenticationData({
          userId: "my-user-id-that-is-NOT-related-to-application-id",
          password: "my-password-that-is-NOT-related-to-secret"
        });

        roomExpress = new sdk.express.RoomExpress({
          treatBackgroundAsOffline: false,
          adminApiProxyClient: adminApiProxyClient
          /* uri: app.getUri(),
          shaka: shaka */
        });

        /* if (app.getUrlParameter('debug') === 'true') {
          app.addDebugAppender(roomExpress.getPCastExpress().getPCast());
        } */

        joinRoom();
      };

      sdk.utils.rtc.getSources(function(sources) {
        videoSources = sources.filter(function(source) {
          return source.kind === "video";
        });
        audioSources = sources.filter(function(source) {
          return source.kind === "audio";
        });
      });

      function joinRoom() {
        var roomAlias =
          process.env.NODE_ENV === "production"
            ? "vici-tv-psg"
            : "vici-tv-psg-dev";
        var role = "Audience";

        roomExpress.joinRoom(
          {
            alias: roomAlias,
            role: role // Set your role for yourself. Participant will view and interact with other members (must have streams). Audience just watches.
          },
          function joinRoomCallback(error, response) {
            if (error) {
              setUserMessage("Unable to join room: " + error.message);
              self.leaveRoomAndStopPublisher();

              throw error;
            }

            if (response.status !== "ok" && response.status !== "ended") {
              setUserMessage("New Status: " + response.status);

              throw new Error(response.status);
            }

            setUserMessage("Joined room");

            if (!roomService) {
              roomService = response.roomService;
            }

            /* displayElement(publishScreenShareButton); */

            /* var chatService = response.roomService.getChatService();

            chatService.start(3);

            chatService.getObservableChatEnabled().subscribe(
              function(enabled) {
                if (enabled) {
                  console.log("Chat is enabled");
                } else {
                  console.log("Chat is DISABLED");
                }
              },
              { initial: "notify" }
            );

            chatService
              .getObservableLastChatMessage()
              .subscribe(function(message) {
                console.log(
                  "Received message [" +
                    message.messageId +
                    "]/[" +
                    new Date(message.timestamp) +
                    "]: [" +
                    message.message +
                    "]"
                );
              });

            chatService
              .getObservableChatMessages()
              .subscribe(function(messages) {
                console.log(
                  "Current chat history is [" + messages.length + "] messages"
                );
              });

            var messageIdx = 0;

            sendMessageIntervalId = setInterval(function sendMessage() {
              if (!chatService.getObservableChatEnabled().getValue()) {
                return;
              }

              if (!chatService.canSendMessage()) {
                console.log("Can NOT send messages right now");

                return;
              }

              var message = "Test message " + messageIdx++ + ":" + _.now();

              chatService.sendMessageToRoom(message, function(error, result) {
                if (error) {
                  console.error("Failed to send message", error);

                  return;
                }

                console.log(
                  "Sent message to room with status ",
                  _.get(result, ["status"]),
                  ": ",
                  message
                );
              });
            }, 5000); */
          },
          function membersChangedCallback(members) {
            // This is triggered every time a member joins or leaves
            console.log("Members updated, count=[" + members.length + "]");
            removeOldMembers(members);
            addNewMembers(members);

            self.numMembers = members.length;
            self.$emit("fanfest-members", members.length);
          }
        );
      }

      function removeOldMembers(members) {
        var membersThatLeft = membersStore.filter(function(member) {
          return !members.includes(member);
        });

        membersThatLeft.forEach(function(memberThatLeft) {
          var memberSubscription =
            memberSubscriptions[memberThatLeft.getSessionId()];

          if (memberSubscription) {
            memberSubscription.forEach(function(subscription) {
              removeMemberStream(
                subscription.memberStream,
                memberThatLeft.getSessionId()
              );
            });
          }

          delete memberSubscriptions[memberThatLeft.getSessionId()];
        });

        membersStore = membersStore.filter(function(member) {
          return !membersThatLeft.includes(member);
        });
      }

      function removeMemberStream(memberStream, memberSessionId) {
        var streamInfo = memberStream.getInfo();
        let isHost = streamInfo.isHost;
        if (isHost == true)
          self.$store.commit("hasHost", false);
        
        var memberSubscriptionToRemove = memberSubscriptions[
          memberSessionId
        ].find(function(memberSubscription) {
          return (
            memberStream.getPCastStreamId() ===
            memberSubscription.memberStream.getPCastStreamId()
          );
        });

        memberSubscriptions[memberSessionId] = memberSubscriptions[
          memberSessionId
        ].filter(function(memberSubscription) {
          return (
            memberStream.getPCastStreamId() !==
            memberSubscription.memberStream.getPCastStreamId()
          );
        });

        if (memberSubscriptionToRemove) {
          memberSubscriptionToRemove.mediaStream.stop();
          memberSubscriptionToRemove.videoElement.remove();

          return true;
        }

        return false;
      }

      function addNewMembers(members) {
        var membersThatJoined = members.filter(function(member) {
          return !membersStore.includes(member);
        });

        membersThatJoined.forEach(function(newMember) {
          var memberSessionId = newMember.getSessionId();

          memberSubscriptions[memberSessionId] = [];

          // Listen for changes to member streams. This will happen when the publisher fails and it recovers, or when adding or removing a screen share
          var memberStreamSubscription = newMember
            .getObservableStreams()
            .subscribe(function(memberStreams) {
              if (!memberSubscriptions[memberSessionId]) {
                return memberStreamSubscription.dispose();
              }

              // Remove old streams
              memberSubscriptions[memberSessionId].forEach(function(
                memberSubscription
              ) {
                var shouldRemoveMember = !memberStreams.find(function(stream) {
                  return (
                    stream.getPCastStreamId() ===
                    memberSubscription.memberStream.getPCastStreamId()
                  );
                });

                if (shouldRemoveMember) {
                  removeMemberStream(
                    memberSubscription.memberStream,
                    memberSessionId
                  );
                }
              });

              // Subscribe to new streams
              memberStreams
                .filter(function(memberStream) {
                  return !memberSubscriptions[memberSessionId].find(function(
                    memberSubscription
                  ) {
                    return (
                      memberStream.getPCastStreamId() ===
                      memberSubscription.memberStream.getPCastStreamId()
                    );
                  });
                })
                .forEach(function(memberStream) {
                  subscribeToMemberStream(memberStream, memberSessionId);
                });
            });

          newMember
            .getObservableStreams()
            .getValue()
            .forEach(function(memberStream) {
              subscribeToMemberStream(memberStream, memberSessionId);
            });
        });

        membersStore = members;
      }

      function subscribeToMemberStream(memberStream, sessionId) {
        var videoElement = createVideo();
        var streamInfo = memberStream.getInfo(); // Access the custom stream info params that you passed when publishing
        // var isSelf = sessionId === roomService.getSelf().getSessionId(); // Check if is yourself!
        var isSelf = self.$props.screenName === streamInfo.screenName;
        videoElement.setAttribute("u", streamInfo.screenName);

        if (isSelf) {
          // return; // Ignore self
          videoElement.muted = true; // Don't want to hear yourself
        } else {
          videoElement.muted = self.$props.shouldMute;
        }

        /* if (app.getUrlParameter("multipleQualities")) {
          videoElement.classList.add(streamInfo.quality);
        } */

        var subscribeOptions = {
          videoElement: videoElement,
          monitor: { callback: onMonitorEvent }
        };
        var handleSubscribe = function(error, response) {
          if (!response || !response.mediaStream) {
            return;
          }

          // Make sure we don't end up with 2 streams due to auto recovery
          var removed = removeMemberStream(memberStream, sessionId);

          memberSubscriptions[sessionId].push({
            mediaStream: response.mediaStream,
            videoElement: videoElement,
            isSelf: isSelf,
            memberStream: memberStream,
            screenName: streamInfo.screenName
          });

          /* var divToUpdate;
          for (const v of self.$props.videoList) {
            if (!v.hasChildNodes()) {
              divToUpdate = v;
              break;
            }
          }

          divToUpdate.append(videoElement); */
          console.log("streamInfo" + JSON.stringify(streamInfo));
          var divToUpdate;

          let isHost = streamInfo.isHost;
          if (isHost == true) {
            divToUpdate = document.getElementById("fanfestHost");
            videoElement.classList.add("embed-responsive-item");
            self.$store.commit("hasHost", true);
          } else {
            divToUpdate = self.$props.videoList[0];
            // Hide initially until video can be properly formatted
            videoElement.classList.add("d-none");
          }

          setTimeout(()=>{
            divToUpdate.append(videoElement);
          },1000)

          self.checkMute();

          if (removed) {
            console.log(
              "Replaced member subscription for session ID [" + sessionId + "]"
            );
          }
        };

        roomExpress.subscribeToMemberStream(
          memberStream,
          subscribeOptions,
          handleSubscribe
        );
      }

      function setUserMessage(message) {
        /* var userMessageElement = document.getElementById('userMessage');

        userMessageElement.innerText = message; */
        // alert(`${message}`);
        console.log("[vici]: " + message);

        var streamer = self.$props.screenName ? self.$props.screenName : "nada";
        logger.info("user: " + streamer);
        logger.info(message, {
          streamer: streamer
        });
      }

      // This will get called when the stream fails to recover from an issue
      function onMonitorEvent(error, response) {
        if (error) {
          return; // May want to display something indicating failure for member
        }

        if (response.status !== "ok") {
          console.log(
            "Member stream subscription failed [%s]",
            response.status
          ); // May want to display something indicating failure for member
        }

        // You may have the option to automatically retry
        if (response.retry) {
          console.log(
            "Attempting to redo member stream subscription after failure"
          ); // May want to display something indicating failure for member

          response.retry();
        }
      }

      function createVideo() {
        var videoElement = document.createElement("video");

        videoElement.setAttribute("playsline", ""); // For Safari and IOS
        videoElement.setAttribute("autoplay", ""); // For Safari and IOS + Mobile
        videoElement.muted = self.$props.shouldMute;

        // To resolve unintended pauses
        videoElement.onpause = function() {
          setTimeout(function() {
            videoElement.play();
          }, 10);
        };

        return videoElement;
      }

      /* function publishScreen() {
        hideElement(publishScreenShareButton);
        displayElement(stopScreenShareButton);

        var roomAlias = $('#alias').val();
        var videoElement = createVideo();
        var publishOptions = {
          capabilities: ['fhd', 'prefer-h264'], // Add other capabilities if you like. Prefer-h264 allows publishing/viewing on Safari/IOS 11
          room: {
            alias: roomAlias,
            name: roomAlias,
            type: 'MultiPartyChat'
          }, // Set alias so that you can always uniquely identify room without accessing the return value
          screenName: screenName,
          streamType: 'Presentation', // Distinguish from normal publisher
          memberRole: memberRole,
          videoElement: videoElement,
          monitor: { callback: onMonitorEvent }
        };

        videoElement.setAttribute('muted', true); // Don't want to hear yourself

        return roomExpress.publishScreenToRoom(publishOptions, function (error, response) {
          if (error) {
            setUserMessage('Unable to publish to Room: ' + error.message);

            throw error;
          }

          if (response.status !== 'ok' && response.status !== 'ended') {
            setUserMessage('New Status: ' + response.status);

            throw new Error(response.status);
          }

          if (response.status === 'ok') {
            screenPublisher = {
              publisher: response.publisher,
              videoElement: videoElement
            };

            selfVideoList.append(videoElement);
          }
        });
      } */

      /* function stopPublishScreen() {
        displayElement(publishScreenShareButton);
        hideElement(stopScreenShareButton);

        if (screenPublisher) {
          screenPublisher.publisher.stop();
          screenPublisher.videoElement.remove();

          screenPublisher = null;
        }
      } */

      if (self.canStream) {
        // self.$refs.startPublishButton.onclick = self.stream;
        // self.$refs.stopPublishButton.onclick = self.leaveRoomAndStopPublisher;
      }

      /* publishAndJoinRoomButton.onclick = publishVideoAndCameraAtTwoQualitiesAndJoinRoom;
      stopButton.onclick = leaveRoomAndStopPublisher;
      publishScreenShareButton.onclick = publishScreen;
      stopScreenShareButton.onclick = stopPublishScreen; */

      /* app.setOnReset(function () {
        createRoomExpress();
      }); */
      if (!roomExpress) createRoomExpress();
      else joinRoom();
    },
    stream: function() {
      const self = this;

      console.log("Attempting to start publishing...");
      self.$refs.startPublishButton.disabled = true;

      if (videoSources.length === 0 || audioSources.length === 0) {
        return console.log("Sources not available yet");
      }

      /* hideElement(publishAndJoinRoomButton);
        displayElement(stopButton); */

      let videoConfig =
        isMobileAppleDevice || isOtherMobile
          ? { facingMode: { exact: "user" } }
          : true;

      var roomAlias =
        process.env.NODE_ENV === "production"
          ? "vici-tv-psg"
          : "vici-tv-psg-dev";
      //var videoElement = createVideo();
      //videoElement.classList.add("embed-responsive-item");
      //var cameraSelection = self.didSelectUserCam ? "user" : "environment";
      var publishOptions = {
        capabilities: [
          "sd",
          // "prefer-h264",
          "low-latency",
          "streaming",
          "on-demand"
        ], // Add other capabilities if you like. Prefer-h264 allows publishing/viewing on Safari/IOS 11
        room: {
          alias: roomAlias,
          name: roomAlias,
          type: "MultiPartyChat"
        }, // Set alias so that you can always uniquely identify room without accessing the return value
        mediaConstraints: {
          //audio: { deviceId: audioSources[0].id },
          //video: { deviceId: videoSources[0].id }
          // video: { facingMode: { exact: cameraSelection } }, // Include camera
          video: videoConfig,
          audio: true // Include microphone
        }, // Use the same deviceIds for both
        screenName: self.$props.screenName,
        streamType: "User",
        memberRole: "Participant",

        frameRate: 30,
        //aspectRatio: "16x9",
        //resolution: 480,
        streamInfo: { screenName: self.$props.screenName, isHost: self.canHost ? 1 : 0 }
      };

      /* var highQualityOptions = Object.assign({}, publishOptions, {
          videoElement: videoElement, // Bind local user media to this element (no delay)
          resolution: 720,
          frameRate: 15,
          streamInfo: { quality: "high" } // Pass custom info here
        });
        var lowQualityOptions = Object.assign({}, publishOptions, {
          resolution: 180,
          frameRate: 15,
          streamInfo: { quality: "low" } // Pass custom info here
        }); */

      //videoElement.muted = true; // Don't want to hear yourself

      var publishAndHandleErrors = function(options, callback) {
        // log device info
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
          devices.forEach(function(device) {
            console.log(
              device.kind + ": " + device.label + " id = " + device.deviceId
            );
          });
        });
        let supported = navigator.mediaDevices.getSupportedConstraints();
        console.log(JSON.stringify(supported));

        // publish
        return roomExpress.publishToRoom(options, function(error, response) {
          if (error) {
            console.log("Unable to publish to Room: " + error.message);
            console.log("Time to reload?");
            alert("Error going live in FanFest. Reloading...");
            window.location.reload();
            throw error;
          }

          if (response.status !== "ok" && response.status !== "ended") {
            console.log("New Status: " + response.status);

            throw new Error(response.status);
          }

          if (response.status === "ok") {
            console.log("Online & Publishing");

            callback(response);
          }
        });
      };

      return publishAndHandleErrors(publishOptions, function(response) {
        publisher = {
          publisher: response.publisher
          //videoElement: videoElement
        };

        /* console.log(self.$props.selfVideoList.list)
          console.log(videoElement)
          self.$props.selfVideoList.list.append(videoElement); */

        if (!roomService) {
          roomService = response.roomService;
        }
        self.$refs.startPublishButton.onclick = self.leaveRoomAndStopPublisher;
        self.isStreaming = true;

        setTimeout(() => {
          self.$refs.startPublishButton.disabled = false;
        }, 5000);

        // joinRoom();

        /* if (app.getUrlParameter("multipleQualities")) {
            publishAndHandleErrors(lowQualityOptions, function(response) {
              lowQualityPublisher = { publisher: response.publisher };
            });
          } */
      });
    },
    leaveRoomAndStopPublisher: function leaveRoomAndStopPublisher() {
      // this.$refs.startPublishButton.disabled = false;
      const self = this;
      self.$refs.startPublishButton.disabled = true;

      if (publisher) {
        publisher.publisher.stop();
        //publisher.videoElement.remove();

        publisher = null;
      }

      /* if (lowQualityPublisher) {
        lowQualityPublisher.publisher.stop();

        lowQualityPublisher = null;
      } */

      /* if (screenPublisher) {
        screenPublisher.publisher.stop();
        screenPublisher.videoElement.remove();

        screenPublisher = null;
      } */

      if (roomService) {
        roomService.leaveRoom(function(error, response) {
          roomService = null;

          if (error) {
            throw error;
          }

          if (response.status !== "ok") {
            throw new Error(response.status);
          }

          self.isStreaming = false;

          //self.init();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      }

      if (sendMessageIntervalId) {
        clearInterval(sendMessageIntervalId);

        sendMessageIntervalId = null;
      }

      setTimeout(() => {
        self.$refs.startPublishButton.disabled = false;
      }, 2500);

      /* hideElement(stopButton);
      displayElement(publishAndJoinRoomButton); */
    },
    checkMute: function() {
      const self = this;
      for (const memberKey in memberSubscriptions) {
        //console.log(memberKey)
        for (const memberData of memberSubscriptions[memberKey]) {
          let video = memberData.videoElement;
          let isSelf = memberData.isSelf;
          video.muted = self.$props.shouldMute;
          if (isSelf) video.muted = true; // always mute self
          //console.log(memberData)
          //console.log(video)
        }
      }
    }
  },
  render() {
    // Render the default scoped slot and
    // provide data and method properties
    // via the slot scope.
    return this.$scopedSlots;
  }
};
</script>